import React from 'react'
import styled from 'styled-components'
import { media } from '../theme'
import { transparentize } from 'polished'
import TextHomeEnergyTipsImage from '../assets/images/text--home-energy-tips.svg'
import LogoHawaiiEnergy from '../assets/images/logo--hawaii-energy.svg'
import LogoBluePlanetFoundation from '../assets/images/logo--blue-planet-light.png'

const Container = styled.div`
  align-items: center;
  background: linear-gradient(to right, #1e8899, #012a37);
  box-shadow: inset 0 5px 10px rgba(0, 0, 0, 0.5);
  display: flex;
  height: ${(p) => p.theme.spacing(4)};
  justify-content: center;
  margin-left: -0.5rem;
  overflow: hidden;
  padding: ${(p) => p.theme.spacing(0)};
  position: relative;
  min-width: calc(100% + 1rem);
  z-index: 99;

  ${media.greaterThan('medium')`
    height: ${(p) => p.theme.spacing(5)};
    justify-content: space-between;
    padding: ${(p) => p.theme.spacing(0)} calc(${(p) =>
    p.theme.spacing(2)} + 0.5rem);
  `} @media (min-height: 900px) and (min-width: ${(p) =>
    p.theme.mediaSizes.medium}px) {
    height: ${(p) => p.theme.spacing(6)};
    padding: ${(p) => p.theme.spacing(2)}
      calc(${(p) => p.theme.spacing(2)} + 0.5rem);
  }
`

const Logos = styled.div`
  display: none;

  ${media.greaterThan('medium')`
    display: grid;
    grid-template-columns: auto .1rem auto;
    align-items: center;
    column-gap: ${(p) => p.theme.spacing(0)};
    margin-top: 0.75rem;
  `};
`

const Logo = styled.img`
  height: ${(p) => (p.height ? p.height : '100%')};
`

const HomeEnergyTips = styled.img`
  display: none;
  height: 1.5rem;

  @media (min-width: 48rem) and (min-height: 56.25rem) {
    height: 2rem;
  }

  ${media.greaterThan('medium')`
    display: block;
  `};
`

const BluePlanetFoundation = styled.a`
  height: 1.5rem;
  display: block;

  @media (min-width: 48rem) and (min-height: 56.25rem) {
    height: 2rem;
  }

  img {
    max-height: 100%;
  }
`

const HawaiiEnergy = styled.a`
  height: 1.5rem;
  display: block;

  @media (min-width: 48rem) and (min-height: 56.25rem) {
    height: 2rem;
  }

  img {
    max-height: 100%;
  }
`

const RoomName = styled.h2`
  color: #ffd98f;
  font-size: ${(p) => p.theme.fontSize(3)};
  text-shadow: 0.05em 0.05em 0 ${transparentize(0.4, '#022c37')};
  text-transform: uppercase;

  ${media.greaterThan('medium')`
    font-size: ${(p) => p.theme.fontSize(4)};
  `};

  @media (min-width: 48rem) and (min-height: 56.25rem) {
    font-size: ${(p) => p.theme.fontSize(5)};
  }
`

const Links = styled.div`
  display: none;
  margin-left: ${(p) => p.theme.spacing(4)};
  flex-direction: column;
  align-items: flex-end;

  ${media.greaterThan('medium')`
    display: flex;
  `};
`

const Divider = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
`

const Footer = ({ roomName, ...props }) => {
  return (
    <Container {...props}>
      <RoomName>{roomName}</RoomName>

      <Links>
        <HomeEnergyTips src={TextHomeEnergyTipsImage} />

        <Logos>
          <HawaiiEnergy
            href="https://hawaiienergy.com"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <Logo src={LogoHawaiiEnergy} height="130%" />
          </HawaiiEnergy>

          <Divider />

          <BluePlanetFoundation
            href="https://blueplanetfoundation.org"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <Logo src={LogoBluePlanetFoundation} height="130%" />
          </BluePlanetFoundation>
        </Logos>
      </Links>
    </Container>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js